"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.js = void 0;
var type = require("./type");
/**
* このモジュールは javascript における基底の関数を定義します。
*/
var js;
(function (js) {
    /**
     * 拡張子取得
     * @param mime マイムタイプ
     */
    function getExtension(mime, default_ext) {
        if (default_ext === void 0) { default_ext = ""; }
        switch (mime) {
            case "application/pdf": return ".pdf";
            case "image/jpeg": return ".jpg";
            case "image/tiff": return ".tif";
            case "image/png": return ".png";
            case "image/bmp": return ".bmp";
            case "text/vnd.rn-realtext": return ".tsv";
            case "text/plain": return ".txt";
        }
        return default_ext;
    }
    js.getExtension = getExtension;
    /**
     * イベント伝搬停止
     * @param e イベントデータ
     */
    function stopPropagation(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.stopPropagation();
        e.returnValue = false;
    }
    js.stopPropagation = stopPropagation;
    /**
     * 数値チェック
     * @param numVal
     */
    function isNumber(numVal) {
        // チェック条件パターン
        var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;
        // 数値チェック
        return pattern.test(numVal);
    }
    js.isNumber = isNumber;
    /**
     * Int変換
     * @param val
     * @param defVal
     */
    function convInt(val, defVal) {
        if (isNaN(val))
            return defVal;
        return parseInt(val);
    }
    js.convInt = convInt;
    /**
     * Float変換
     * @param val
     * @param defVal
     */
    function convFloat(val, defVal) {
        if (isNaN(val))
            return defVal;
        return parseFloat(val);
    }
    js.convFloat = convFloat;
    /**
     * 約数を求める
     * @param num
     */
    function divisor(num) {
        var results = [];
        for (var i = 1; i <= num; i++) {
            if ((num % i == 0)) {
                results.push(i);
            }
        }
        return results;
    }
    js.divisor = divisor;
    /**
     * 文字列容量取得
     * @param str 対象の文字列
     */
    function getStrSize(str) {
        return (new Blob([str], { type: "text/plain" })).size;
    }
    js.getStrSize = getStrSize;
    /**
     * 切り捨て（小数点指定）
     * @param v 数値
     * @param d 保証する小数点桁数（5なら、0.123456→0.12345）
     * @param minval 最小値
     */
    function floor(v, d, minval) {
        if (d === void 0) { d = 5; }
        var dd = (d > 0) ? Math.pow(10, d) : 1;
        var ddd = Math.floor(v * dd) / dd;
        if (minval && minval > ddd)
            ddd = minval;
        return ddd;
    }
    js.floor = floor;
    /**
     * startsWith
     * @param str 文字
     * @param suffix 判定文字
     * @description 組み込みのendsWithは、ieでサポートしない
     */
    function startsWith(str, prefix) {
        return str.lastIndexOf(prefix, 0) === 0;
    }
    js.startsWith = startsWith;
    /**
     * endsWith
     * @param str 文字
     * @param suffix 判定文字
     * @description 組み込みのendsWithは、ieでサポートしない
     */
    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }
    js.endsWith = endsWith;
    /**
     * パディング
     * @param mj 元の文字
     * @param len 文字数
     * @param pad 埋める文字
     * @param isLeft 埋める方向
     */
    function pad(mj, len, pad, isLeft) {
        if (pad === void 0) { pad = "0"; }
        if (isLeft === void 0) { isLeft = true; }
        var padm = "";
        pad = (pad.length > 1) ? pad[0] : pad;
        for (var i = 0; i < (len - mj.length); i++)
            padm += pad;
        if (isLeft)
            return (padm + mj).slice(-len);
        else
            return (mj + padm).slice(-len);
    }
    js.pad = pad;
    /**
     * 配列比較
     * @param a
     * @param b
     */
    function arrayEquals(a, b) {
        if (JSON.stringify(a) == JSON.stringify(b)) {
            return true;
        }
        return false;
    }
    js.arrayEquals = arrayEquals;
    /**
     * 整数部の桁数を取得
     * @param val
     */
    function getDigit(n) {
        return parseInt(n.toString()).toString(10).length;
    }
    js.getDigit = getDigit;
    /**
     * 小数値の桁数を取得
     * @param val
     * @returns 0.1,0.9→1、0.01,0.09→2
     * @description 整数値を指定した場合は、0を返します。
     */
    function getDecDigit(n) {
        if (n == 0)
            return 0;
        if (n >= 1)
            return 0;
        var n2 = Math.abs(n).toFixed(20);
        var ret = 0;
        for (var i = 2; i < n2.length; i++) {
            ret++;
            if (n2[i] != "0") {
                return ret;
            }
        }
        return ret;
    }
    js.getDecDigit = getDecDigit;
    /**
     * 配列値入替
     * @summary 元配列に指定値が含まれる場合は、配列中の要素から削除し、末尾に追加します。
     * @param array 入れ替え元の配列
     * @param val 入れ替える値
     * @returns 値入替後の配列
     */
    function arrayPriority(array, val) {
        if (array[array.length - 1] == val)
            return array;
        for (var i = 0; i < array.length; i++) {
            if (array[i] == val) {
                array.splice(i, 1);
                i--;
            }
        }
        array.push(val);
        return array;
    }
    js.arrayPriority = arrayPriority;
    /**
     * 言語取得
     * @summary ブラウザの言語設定を取得します。
     * @returns 言語設定（ex "ja"等）
     */
    function getLanguage() {
        // 最優先の言語だけ取得
        var language = (window.navigator.languages && window.navigator.languages[0])
            || window.navigator.language;
        // || window.navigator.userLanguage
        // || window.navigator.browserLanguage;
        return language.substring(0, 2);
    }
    js.getLanguage = getLanguage;
    /**
     * バイナリサーチ
     * @param list id-valタイプの配列（検索対象。id順に並んでる必要がある）
     * @param id 検索するID
     */
    function binarySearch(list, f, id) {
        var index = -1;
        var head = 0;
        var tail = list.length;
        while (head <= tail) {
            var center = Math.floor((head + tail) / 2);
            var centerVal = f(center); //list[center].id;
            if (centerVal === id) {
                index = center;
                break;
            }
            if (centerVal < id) {
                head = center + 1;
            }
            else {
                tail = center - 1;
            }
        }
        return index;
    }
    js.binarySearch = binarySearch;
    /**
    * getElementById
    * @summary getElementByIdの短縮書式を提供します。
    * @param id elementのID
    * @returns 取得要素オブジェクト
    */
    function gE(id) {
        return document.getElementById(id);
    }
    js.gE = gE;
    /**
    * createElement
    * @summary createElementの短縮書式を提供します。
    * @param tagName 生成するタグ名
    * @returns 取得要素オブジェクト
    */
    function cE(tagName) {
        return document.createElement(tagName);
    }
    js.cE = cE;
    /**
    * mapper付きcast
    * @summary obj側のキーが「-」付きの場合、「-」を除去した上でプロパティとしてセットします。
    * @param obj
    * @param environment
    * @param clazz
    * @param castMapper
    */
    function cast(obj, environment, clazz, castMapper) {
        if (castMapper === void 0) { castMapper = null; }
        var instance = new clazz();
        for (var prop in obj) {
            if (!obj.hasOwnProperty(prop)) {
                continue;
            }
            // cast時に設定先となるkey名。設定元に「-」が付く場合は取り除く
            var setKey = (prop.indexOf("-")) ? prop.replace("-", "") : prop;
            // castする型の検索key
            var schkey = setKey;
            if (castMapper !== undefined) {
                var map = castMapper[getName(instance) + ":" + setKey];
                if (map != null)
                    schkey = map;
            }
            if (is("Array", obj[prop])) {
                instance[setKey] = [];
                for (var i = 0; i < obj[prop].length; i++) {
                    if (typeof obj[prop][i] === "object") {
                        instance[setKey].push(cast(obj[prop][i], environment, environment[schkey], castMapper));
                    }
                    else {
                        instance[setKey].push(obj[prop][i]);
                    }
                }
            }
            else if (typeof obj[prop] === "object") {
                instance[setKey] = cast(obj[prop], environment, environment[schkey], castMapper);
            }
            else {
                instance[setKey] = obj[prop];
            }
        }
        return instance;
    }
    js.cast = cast;
    /**
    * 同期的sleep
    * @summary 同期的にsleepして処理を行います。
    * @param _loopLimit チャレンジする回数
    * @param _interval 間隔(ミリ秒)
    * @param _mainFunc 実行関数(return falseでbreakする）
    */
    function loopSleep(_loopLimit, _interval, _mainFunc, loopName, failFunc) {
        if (loopName === void 0) { loopName = ""; }
        if (failFunc === void 0) { failFunc = null; }
        loopSleepWithIntervalFunc(_loopLimit, function (n) { return _interval; }, _mainFunc, loopName, failFunc);
    }
    js.loopSleep = loopSleep;
    /**
     * 同期的Sleep。Wait時間をfibonacci数で指定する。
     * @param _loopLimit number of challenges
     * @param _initial フィボナッチ数の計算の初期値。注意)指数関数的にWait時間が増えるので10未満の値を指定するのが望ましい。
     * @param _mainFunc 実行関数。
     * @param loopName
     * @param failFunc
     */
    function loopSleepFibonacci(_loopLimit, _initial, _mainFunc, loopName, failFunc) {
        if (loopName === void 0) { loopName = ""; }
        if (failFunc === void 0) { failFunc = null; }
        var f_calculate = function (i) {
            return (i <= 2) ? 1 : f_calculate(i - 1) + f_calculate(i - 2);
        };
        var f_fib = function (i) {
            return f_calculate(i + _initial);
        };
        loopSleepWithIntervalFunc(_loopLimit, f_fib, _mainFunc, loopName, failFunc);
    }
    js.loopSleepFibonacci = loopSleepFibonacci;
    /**
     * 任意の関数でWait時間をカスタマイズ可能な同期的sleep。
     * @param _loopLimit
     * @param f_interval
     * @param _mainFunc
     * @param loopName
     * @param failFunc
     */
    function loopSleepWithIntervalFunc(_loopLimit, f_interval, _mainFunc, loopName, failFunc) {
        if (loopName === void 0) { loopName = ""; }
        if (failFunc === void 0) { failFunc = null; }
        var i = 0;
        var data = "";
        // change recursive call to normal loop. because console trace become useless.(tail call optimization not enabled before es6)
        var htm = -1;
        var timerfunc = function () {
            var result = _mainFunc(i, data);
            if (result === false) {
                // break機能
                if (htm >= 0) {
                    clearInterval(htm);
                }
                return result;
            }
            if (++i > _loopLimit) {
                // retry over...
                if (htm >= 0) {
                    clearInterval(htm);
                }
                if (console) {
                    var f = (console.warn || console.trace);
                    if (f) {
                        try {
                            console.log(f);
                            f(["jsUtil::loopSleep failed.", "name: " + loopName || "noname", "looplimit: " + _loopLimit].join(', '));
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                }
                if (failFunc) {
                    failFunc();
                }
            }
            return result;
        };
        if (timerfunc() === false) {
            return;
        }
        var interval = f_interval(1);
        htm = setInterval(function () {
            timerfunc();
            interval = f_interval(i);
        }, interval);
    }
    js.loopSleepWithIntervalFunc = loopSleepWithIntervalFunc;
    /**
    * UUID生成
    * @summary ランダムなUUIDを生成する
    * @returns uuid
    */
    function uuid(hyphen, digits) {
        if (hyphen === void 0) { hyphen = true; }
        if (digits === void 0) { digits = 0; }
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        var h = hyphen ? "-" : "";
        var id = s4() + s4() + h + s4() + h + s4() + h + s4() + h + s4() + s4() + s4();
        if (digits > 0) {
            id = id.substr(0, digits);
        }
        return id;
    }
    js.uuid = uuid;
    /**
     * JSONで返却される日付を整形する
     * @param str
     * @param is_datetime
     */
    function getDateString(str, is_datetime) {
        if (is_datetime === void 0) { is_datetime = true; }
        var yyyy = str.substr(0, 4);
        var mm = str.substr(5, 2);
        var dd = str.substr(8, 2);
        var hh = str.substr(11, 2);
        var ii = str.substr(14, 2);
        var ss = str.substr(17, 2);
        if (is_datetime) {
            return yyyy + "/" + mm + "/" + dd + " " + hh + ":" + ii + ":" + ss;
        }
        else {
            return yyyy + "/" + mm + "/" + dd;
        }
    }
    js.getDateString = getDateString;
    /**
     * 型判定
     * @summary 以下の文字列をtypeとして渡すことでobjが指定の型か判定する
     * @param type 型タイプ文字列（String,Number,Boolean,Date,Error,Array,Function,RegExp,Object）
     * @param obj 判定先オブジェクト
     * @returns 指定型タイプの場合にtrue
     */
    function is(type, obj) {
        var clas = Object.prototype.toString.call(obj).slice(8, -1);
        return obj !== undefined && obj !== null && clas === type;
    }
    js.is = is;
    /**
    * クラス名取得
    * @summary 指定クラスの型名を取得する
    * @param obj 型名を知りたいオブジェクト
    * @returns 型名の文字列
    */
    function getName(obj) {
        if (obj.constructor === undefined) {
            return "";
        }
        else if (obj.constructor.name === undefined || obj.constructor.name.toLowerCase() == "function") {
            var regx = /function (\w*)/;
            var tmpname = obj.constructor.toString().match(regx)[1];
            if (tmpname.toLowerCase() == "function") {
                tmpname = obj.toString().match(regx)[1];
            }
            return tmpname;
        }
        else {
            return obj.constructor.name;
        }
    }
    js.getName = getName;
    /**
    * デフォルト値補完
    * @summary 指定値が定義されていない場合、デフォルト値を返却します。
    * @param val 指定値
    * @param defval デフォルト値
    * @returns 指定値 もしくは、デフォルト値
    */
    function getValue(val, defval) {
        if (val == null || val === undefined) {
            return defval;
        }
        else {
            return val;
        }
    }
    js.getValue = getValue;
    function mjBase64Decode(mj) {
        return decodeURIComponent(escape(window.atob(mj)));
    }
    js.mjBase64Decode = mjBase64Decode;
    function escapeforhtml(mj) {
        return mj.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    js.escapeforhtml = escapeforhtml;
    function formatDate(date, format) {
        format = format.replace(/yyyy/g, date.getFullYear().toString());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
        format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
        format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
        format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
        format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
        return format;
    }
    js.formatDate = formatDate;
    ;
    /**
    * remove to duplicated char to specify string.
    * @param a
    */
    function removeDuplicate(a) {
        var temp = {};
        for (var i = 0; i < a.length; i++) {
            temp[a[i]] = true;
        }
        return Object.keys(temp);
    }
    js.removeDuplicate = removeDuplicate;
    /** decode the base64 string (instead of mjBase64Decode??)*/
    js.b64decode = (function (i, tbl) {
        for (i = 0, tbl = { 61: 64, 47: 63, 43: 62 }; i < 62; i++) {
            tbl[i < 26 ? i + 65 : (i < 52 ? i + 71 : i - 4)] = i;
        } //A-Za-z0-9+/=
        return function (str) {
            var j, len, arr, buf;
            if (!str || !str.length) {
                return [];
            }
            for (i = 0, len = str.length, arr = [], buf = []; i < len; i += 4) { //6,2+4,4+2,6
                for (j = 0; j < 4; j++) {
                    buf[j] = tbl[str.charCodeAt(i + j) || 0];
                }
                arr.push(buf[0] << 2 | (buf[1] & 63) >>> 4, (buf[1] & 15) << 4 | (buf[2] & 63) >>> 2, (buf[2] & 3) << 6 | buf[3] & 63);
            }
            if (buf[3] === 64) {
                arr.pop();
                if (buf[2] === 64) {
                    arr.pop();
                }
            }
            return arr;
        };
    }());
    /**
     * calc string length with surrogate pair.
     * @param str specify the string that masure length.
     */
    function strlen(str) {
        return str.length - (str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || []).length;
    }
    js.strlen = strlen;
    /**
     * detect specify char(as str argument) is high-byte of surrogate pair.
     * @param str
     */
    function isHighSurrogate(str) {
        return (str[0] >= '\uD800' && str[0] <= '\uDFFF');
    }
    js.isHighSurrogate = isHighSurrogate;
    /**
     * Disassemble the character from string conscious of surrogate pair.
     * useful for map/filter...etc
     * @param str
     */
    function decompString(str) {
        var dst = [];
        stringForEach(str, function (c) {
            dst.push(c);
        });
        return dst;
    }
    js.decompString = decompString;
    /**
     * foreach by specify string conscious of surrogate pair.
     * @param str
     * @param fn
     */
    function stringForEach(str, fn) {
        for (var i = 0; i < str.length; ++i) {
            if (isHighSurrogate(str[i])) {
                fn(str[i] + str[++i], i == (str.length - 1));
            }
            else {
                fn(str[i], i == (str.length - 1));
            }
        }
    }
    js.stringForEach = stringForEach;
    /**
     * 文字列のhashを取得
     * @param text
     */
    function getHash(text) {
        var hash = 5381, i = text.length;
        while (i)
            hash = (hash * 33) ^ text.charCodeAt(--i);
        return hash >>> 0;
    }
    js.getHash = getHash;
    ;
    /**
     * ブラウザタイプ判別
     */
    function getBrowser() {
        var ua = window.navigator.userAgent.toLowerCase();
        var ver = window.navigator.appVersion.toLowerCase();
        var name = "";
        var version = "";
        if (ua.indexOf("msie") != -1) {
            name = "ie";
            if (ver.indexOf("msie 6.") != -1) {
                version = "6";
            }
            else if (ver.indexOf("msie 7.") != -1) {
                version = "7";
            }
            else if (ver.indexOf("msie 8.") != -1) {
                version = "8";
            }
            else if (ver.indexOf("msie 9.") != -1) {
                version = "9";
            }
            else if (ver.indexOf("msie 10.") != -1) {
                version = "10";
            }
        }
        else if (ua.indexOf('trident/7') != -1) {
            name = "ie";
            version = "11";
        }
        else if (ua.indexOf('edge') != -1) {
            name = "edge";
        }
        else if (ua.indexOf('chrome') != -1) {
            name = 'chrome';
        }
        else if (ua.indexOf('safari') != -1) {
            name = 'safari';
        }
        else if (ua.indexOf('opera') != -1) {
            name = 'opera';
        }
        else if (ua.indexOf('firefox') != -1) {
            name = 'firefox';
        }
        return { name: name, version: version };
    }
    js.getBrowser = getBrowser;
    ;
    /**
     * 2点間の距離を求める
     * @param a 1点目
     * @param b 2点目
     */
    function getDistance(a, b) {
        return Math.sqrt((b.x - a.x) * (b.x - a.x) + (b.y - a.y) * (b.y - a.y));
    }
    js.getDistance = getDistance;
    /**
     * 角度(deg)正規化
     * @summary （0-360[0-2π]にあわせる)
     * @param deg
     */
    function normDeg(deg) {
        if (0 <= deg && deg < 360)
            return deg;
        deg = deg % 360;
        if (deg >= 0)
            return deg;
        return 360 + deg;
    }
    js.normDeg = normDeg;
    /**
     * 角度からradianを変換する
     * @param deg
     */
    function rad(deg) {
        return deg * Math.PI / 180;
    }
    js.rad = rad;
    /**
     * マトリックス適用（ポイント）
     * @summary ポイントに任意のマトリックスを適用した際のポイントを求めます。
     * @param pt 適用元のポイント
     * @param matrix 適用するマトリックス
     * @returns 適用後のポイントを返却します。
     */
    function setPointMatrix(pt, matrix) {
        var rPt = { x: 0, y: 0 };
        rPt.x = pt.x * matrix[0] + pt.y * matrix[2] + matrix[4];
        rPt.y = pt.x * matrix[1] + pt.y * matrix[3] + matrix[5];
        return rPt;
    }
    js.setPointMatrix = setPointMatrix;
    /**
     * マトリックス適用（9点）
     * @summary ポイントに任意のマトリックスを適用した際のポイントを求めます。
     * @param pts 適用元の9点
     * @param matrix 適用するマトリックス
     * @returns 適用後のポイントを返却します。
     */
    function setPointsMatrix(pts, matrix) {
        var results = [];
        for (var i = 0; i < pts.length; i++) {
            results[i] = setPointMatrix(pts[i], matrix);
        }
        return results;
    }
    js.setPointsMatrix = setPointsMatrix;
    /**
     * マトリックス合成
     * @summary aMatrix と bMatrix を合成した結果の cMatrix を返却します。
     * <br/> bにベース(基準となるマトリックス)を、aにカレント（上乗せで合成するマトリックス）を設定します。
     * <br/> bMatrix 　aMatrix　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　cMatrix
     * <br/> {a,c,e}   {A,C,E}   {a*A+c*B+e*0, a*C+c*D+e*0, a*E+c*F+e*1}   {a*A+c*B, a*C+c*D, a*E+c*F+e}   {①,③,⑤}
     * <br/> {b,d,f}   {B,D,F} = {b*A+d*B+f*0, b*C+d*D+f*0, b*E+d*F+f*1} = {b*A+d*B, b*C+d*D, b*E+d*F+f} = {②,④,⑥} = [①,②,③,④,⑤,⑥]
     * <br/> {0,0,1}   {0,0,1}   {0*A+0*B+1*0, 0*C+0*D+1*0, 0*E+0*F+1*1}   {0      , 0      , 1        }   {0 ,0 ,1 }
     * @param aMatrix カレントマトリックス
     * @param bMatrix ベースマトリックス
     * @summary 合成結果のマトリックスを返却します。
     */
    function matrix2(aMatrix, bMatrix) {
        return [
            bMatrix[0] * aMatrix[0] + bMatrix[2] * aMatrix[1],
            bMatrix[1] * aMatrix[0] + bMatrix[3] * aMatrix[1],
            bMatrix[0] * aMatrix[2] + bMatrix[2] * aMatrix[3],
            bMatrix[1] * aMatrix[2] + bMatrix[3] * aMatrix[3],
            bMatrix[0] * aMatrix[4] + bMatrix[2] * aMatrix[5] + bMatrix[4],
            bMatrix[1] * aMatrix[4] + bMatrix[3] * aMatrix[5] + bMatrix[5]
        ];
    }
    js.matrix2 = matrix2;
    /**
     * マトリックスの逆変換
     * @param matrix
     */
    function matrixInverse(matrix) {
        var i = matrix[0] * matrix[3] - matrix[1] * matrix[2];
        if (Math.abs(i) == 0) {
            return matrix;
        }
        var j = -i;
        var a = matrix[3] / i;
        var b = matrix[1] / j;
        var c = matrix[2] / j;
        var d = matrix[0] / i;
        var e = (matrix[2] * matrix[5] - matrix[3] * matrix[4]) / i;
        var f = (matrix[0] * matrix[5] - matrix[1] * matrix[4]) / j;
        return [a, b, c, d, e, f];
    }
    js.matrixInverse = matrixInverse;
    /**
     * 座標回転
     * @summary 開始点(s)を基準点(b)を軸にrad分回転した際のpointを求めます。
     * @param b 基準点
     * @param s 開始点
     * @param rad 回転角度
     * @returns sの回転後の point を返却します。
     */
    function getPointWithRotate(b, s, rad) {
        var dx = s.x - b.x;
        var dy = s.y - b.y;
        var cx = dx * Math.cos(rad) - dy * Math.sin(rad) + b.x;
        var cy = dx * Math.sin(rad) + dy * Math.cos(rad) + b.y;
        return { x: cx, y: cy };
    }
    js.getPointWithRotate = getPointWithRotate;
    /**
     * 9点座標の角4点におけるコマンドを返却する
     * @param gpt 9点配列
     */
    function getCommandsOfPoints(gpt) {
        var p = [];
        p.push(new type.drawCommand("m", [gpt[0].x, gpt[0].y]));
        p.push(new type.drawCommand("l", [gpt[2].x, gpt[2].y]));
        p.push(new type.drawCommand("l", [gpt[8].x, gpt[8].y]));
        p.push(new type.drawCommand("l", [gpt[6].x, gpt[6].y]));
        p.push(new type.drawCommand("h"));
        return p;
    }
    js.getCommandsOfPoints = getCommandsOfPoints;
    function getPoint(x, y) {
        return { x: x, y: y };
    }
    /**
     * インナー判定（パス＜ポイント）
     * @summary 指定したポイントがパスの中に存在するかチェックする
     * @param commands パスコマンド
     * @param pt 判定ポイント
     * @param isConvCmds コマンドの平たん化を内部で実施するか？※外側でやった上でコールする場合は false
     * @param isOnline 線上を交差と内部とみなすか
     * @param minValue 線上交差判定の許容値
     * @returns 判定ポイントがパスコマンドの内部に存在する場合、 true を返却します。
     */
    function chkInner(commands, pt, isConvCmds, isOnline, minValue) {
        if (isConvCmds === void 0) { isConvCmds = true; }
        if (isOnline === void 0) { isOnline = false; }
        if (minValue === void 0) { minValue = Number.MIN_VALUE; }
        var lastPt = getPoint(0, 0);
        //var commands2 = (isConvCmds) ? getFlatCommandsOfCommands(commands) : commands;
        var commands2 = commands;
        // 閉領域にならないパス数分の場合は終了
        if (commands2.length <= 2) {
            return false;
        }
        // ptをX方向に伸ばした線にぶつかる辺の数で判定する
        // →奇数＝Inner
        // 判定線分
        var hitCnt = 0;
        var pt2p = getPoint(pt.x + 10000, pt.y + 1); // 真横は何かと危ない
        var pt2m = getPoint(pt.x + 10000, pt.y - 1); // 真横は何かと危ない
        var cross1fm = getPoint(pt.x - minValue, pt.y - minValue);
        var cross1to = getPoint(pt.x + minValue, pt.y + minValue);
        var cross2fm = getPoint(pt.x + minValue, pt.y - minValue);
        var cross2to = getPoint(pt.x - minValue, pt.y + minValue);
        var b1 = getPoint(0, 0);
        var b2 = getPoint(0, 0);
        // 判定
        var onLFlg = false;
        for (var i = 0; i < commands2.length; i++) {
            var ope = getPoint(commands2[i].params[0], commands2[i].params[1]);
            if (i == 0) {
                lastPt.x = ope.x;
                lastPt.y = ope.y;
                continue;
            }
            if (commands2[i].command == "h")
                continue;
            b1.x = lastPt.x;
            b1.y = lastPt.y;
            b2.x = ope.x;
            b2.y = ope.y;
            if (isOnline)
                onLFlg = onLFlg || chkInterested(cross1fm, cross1to, b1, b2, true) || chkInterested(cross2fm, cross2to, b1, b2, true);
            if (chkInterested(pt, pt2p, b1, b2, false) || chkInterested(pt, pt2m, b1, b2, false)) {
                hitCnt++;
            }
            lastPt.x = ope.x;
            lastPt.y = ope.y;
        }
        // 最終点から始点までを判定
        if (b2.x != commands2[0].params[0] || b2.y != commands2[0].params[1]) {
            b1.x = b2.x;
            b1.y = b2.y;
            b2.x = commands2[0].params[0];
            b2.y = commands2[0].params[1];
            if (isOnline)
                onLFlg = onLFlg || chkInterested(cross1fm, cross1to, b1, b2, true) || chkInterested(cross2fm, cross2to, b1, b2, true);
            if (chkInterested(pt, pt2p, b1, b2, false) || chkInterested(pt, pt2m, b1, b2, false)) {
                hitCnt++;
            }
        }
        if (isOnline && onLFlg)
            return true;
        return (hitCnt % 2 == 0) ? false : true;
    }
    js.chkInner = chkInner;
    /**
     * 交差判定
     * @summary線分a1-a2とb1-b2が交差するか判定する
     * @param a1 線分a1
     * @param a2 線分a2
     * @param b1 線分b1
     * @param b2 線分b2
     * @param isOnline 線上を交差と内部とみなすか
     * @returns 交差する場合、 true を返却します。
     */
    function chkInterested(a1, a2, b1, b2, isOnline) {
        if (isOnline === void 0) { isOnline = false; }
        var ta = (b1.x - b2.x) * (a1.y - b1.y) + (b1.y - b2.y) * (b1.x - a1.x);
        var tb = (b1.x - b2.x) * (a2.y - b1.y) + (b1.y - b2.y) * (b1.x - a2.x);
        var tc = (a1.x - a2.x) * (b1.y - a1.y) + (a1.y - a2.y) * (a1.x - b1.x);
        var td = (a1.x - a2.x) * (b2.y - a1.y) + (a1.y - a2.y) * (a1.x - b2.x);
        if (isOnline) {
            return tc * td <= 0 && ta * tb <= 0;
        }
        else {
            return tc * td < 0 && ta * tb < 0;
        }
    }
    js.chkInterested = chkInterested;
    /**
     * リクエストヘッダーにおける指摘キーの値を取得する
     * @param req
     * @param key
     */
    function getReqHeader(req, key) {
        var a = req.getResponseHeader(key);
        if (a == null)
            a = "";
        return a;
    }
    js.getReqHeader = getReqHeader;
    /**
     * フルパスからファイル名を取得する
     * @param filepath
     */
    function getFileName(filepath) {
        if (filepath) {
            var m = filepath.toString().match(/[^\\/]+$/);
            if (m && m.length > 0) {
                return m[0];
            }
        }
        return filepath;
    }
    js.getFileName = getFileName;
    function getFileNameWithoutExt(filepath) {
        var filename = getFileName(filepath);
        var ext_idx = filename.lastIndexOf(".");
        if (ext_idx > -1) {
            return filename.substr(0, ext_idx);
        }
        return filename;
    }
    js.getFileNameWithoutExt = getFileNameWithoutExt;
    /**
     * 矢印を描画する
     * @param ctx
     * @param apt
     * @param bpt
     * @param tw
     */
    js.drawArrow = function (ctx, apt, bpt, tw) {
        var apts = getPointOfPerpendicular(bpt, apt, tw / 2); // 垂直点
        var spt = getExtendPoint(bpt, apt, Math.sqrt(3) * tw / 2); // 頂点
        ctx.beginPath();
        ctx.moveTo(apts[0].x, apts[0].y);
        ctx.lineTo(spt.x, spt.y);
        ctx.lineTo(apts[1].x, apts[1].y);
        ctx.closePath();
    };
    /**
     * apt→bpt において、bptの垂線上の点を取得する
     * @param apt ベクトルの開始点
     * @param bpt 基準のポイント
     * @param dist 垂線上の距離
     */
    function getPointOfPerpendicular(apt, bpt, dist) {
        var pt = getPointWithRotate(bpt, apt, 0.25 * 2 * Math.PI);
        return [getPoint2(bpt, pt, -dist), getPoint2(bpt, pt, dist)];
    }
    js.getPointOfPerpendicular = getPointOfPerpendicular;
    /**
     * 2点間の 任意距離に位置する点を求める
     * @param a 1点目
     * @param b 2点目
     * @param d 距離
     */
    function getPoint2(a, b, dd) {
        var r = getRadian(a, b);
        var ret = { x: dd * Math.cos(r), y: dd * Math.sin(r) };
        ret.x += a.x;
        ret.y += a.y;
        return ret;
    }
    js.getPoint2 = getPoint2;
    /**
     * 2点の角度を求める(radian）
     * @param a 基準のポイント
     * @param b
     */
    function getRadian(a, b) {
        return normRad(Math.atan2(b.y - a.y, b.x - a.x));
    }
    js.getRadian = getRadian;
    /**
     * 角度(radian)正規化
     * @summary （0-360[0-2π]にあわせる)
     * @param rad
     */
    function normRad(rad) {
        while (rad > 2 * Math.PI) {
            rad -= 2 * Math.PI;
        }
        while (rad < 0) {
            rad += 2 * Math.PI;
        }
        return rad;
    }
    js.normRad = normRad;
    /**
     * 2点の延長線上の点（外分点）を求める
     * @summary a→b方向に、d伸ばした結果を取得します。
     * @param a 始点
     * @param b 終点
     * @param d 延長線上のbからの距離
     */
    function getExtendPoint(a, b, d) {
        var ab = getDistance(a, b);
        return { x: ((ab + d) * b.x - d * a.x) / ab, y: (((ab + d) * b.y - d * a.y) / ab) };
    }
    js.getExtendPoint = getExtendPoint;
    /**
     * 日時を日付文字列に変更する
     * @param a 日時
     * @returns 日付文字列
     */
    function formatDay(a) {
        var b = new Date(a);
        var ret = "";
        ret += b.getFullYear().toString();
        ret += "-";
        ret += (b.getMonth() + 1).toString().padStart(2, '0');
        ret += "-";
        ret += b.getDate().toString().padStart(2, '0');
        ret += " ";
        ret += b.getHours().toString().padStart(2, '0');
        ret += ":";
        ret += b.getMinutes().toString().padStart(2, '0');
        ret += ":";
        ret += b.getSeconds().toString().padStart(2, '0');
        return ret;
    }
    js.formatDay = formatDay;
})(js = exports.js || (exports.js = {}));
